module.exports = __webpack_public_path__ + "static/media/overlay6.49adcf80.png";